const About = () => {
  const aboutList = [
    {
      img: "/images/about1.png",
      txt1: "24시간\u00A0긴급출동",
      txt2: "야간에도 신속하게 출동합니다.",
    },
    {
      img: "/images/about2.png",
      txt1: "인천 전지역 해결전문",
      txt2: "수도권 지역이라면 해결가능합니다.",
    },
    {
      img: "/images/about3.png",
      txt1: "100% 해결가능",
      txt2: "아파트 · 상가 어디든지 해결가능",
    },
    {
      img: "/images/about4.png",
      txt1: "책임설치 · 친절안내",
      txt2: "제품안내 및 기능설명까지 친절안내",
    },
  ];
  return (
    <div
      id="about"
      className="relative w-full h-full px-[calc((100%-var(--container))/2)] mx-auto py-14 lg:py-28 xl:py-36"
    >
      <div
        id="title"
        className="relative w-full h-fit text-center mb-10 xl:mb-20"
      >
        <h2 className="flex items-end justify-center flex-wrap lg:flex-nowrap gap-0.5 font-medium text-black">
          <img
            alt="키플레이어 도어락 로고"
            className="!relative w-auto h-full max-h-8 lg:max-h-12 py-1 object-contain cursor-pointer"
            src="/images/logo.png"
            width={531}
            height={65}
          />
          <span className="-mb-1.5 lg:-mb-2">
            <span className="hidden lg:inline-block">의</span> 혜택 4가지
          </span>
        </h2>
        <p className="my-3 lg:my-5 lg:text-lg">- KEYPLAYER -</p>
        <p className="lg:text-lg text-black">
          도어락 · 열쇠 · 잠금장치 문제 해결은 키플레이어에게&nbsp;맡겨주세요
        </p>
      </div>
      <div className="relative w-full h-fit max-w-[1600px] mx-auto grid grid-cols-1 lg:grid-cols-4 gap-4">
        {aboutList.map((v, i) => (
          <div
            key={i}
            data-aos="fade-up"
            className="relative w-full h-full p-3 border rounded-3xl btn6 inline-block"
          >
            <div className=" relative w-full h-fit my-3 2xl:my-5 text-center">
              <p className="text-font">{v.txt2}</p>
              <h4 className="font-normal text-2xl 2xl:text-2xl text-black mb-3">
                {v.txt1}
              </h4>
            </div>
            <div className="relative w-full h-fit rounded-t-xl overflow-hidden">
              <img
                className="!relative w-full h-full object-cover object-center transition-transform duration-300"
                alt={`키플레이어 도어락 ${v.txt1}`}
                src={v.img}
                width={517}
                height={499}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default About;
